import React from 'react';
import { Link } from 'react-router-dom';
import bannerVideo from './assets/Video.mp4';
import logoIcon from './assets/icon.png';

const Services = () => {
  const services = [
    { 
      image: 'https://images.unsplash.com/photo-1485846234645-a62644f84728?w=400&q=80', 
      title: 'Film Production', 
      desc: 'Full-scale feature film production with professional crew and equipment', 
      path: '/film-production' 
    },
    { 
      image: 'https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=400&q=80', 
      title: 'Short Movies', 
      desc: 'Compelling short films and web series for digital platforms', 
      path: '/short-movies' 
    },
    { 
      image: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=400&q=80', 
      title: 'Academy', 
      desc: 'Professional training in filmmaking, acting, and production techniques', 
      path: '/academy' 
    },
    { 
      image: 'https://images.unsplash.com/photo-1533750349088-cd871a92f312?w=400&q=80', 
      title: 'Ads Making', 
      desc: 'High-impact commercial advertisements and brand promotions', 
      path: '/ads-making' 
    },
    { 
      image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=400&q=80', 
      title: 'Digital Content', 
      desc: 'Web series, commercials, and social media content creation', 
      path: '/digital-content' 
    },
    { 
      image: 'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=400&q=80', 
      title: 'Music Production', 
      desc: 'Original scores, soundtracks, and audio post-production', 
      path: '/music-production' 
    },
  ];

  return (
    <section id="services" className="services-section">
      {/* Video Background */}
      <div className="services-video-background">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="services-background-video"
        >
          <source src={bannerVideo} type="video/mp4" />
        </video>
        <div className="services-video-overlay"></div>
      </div>

      {/* Content */}
      <div className="container services-content">
        <div className="section-header">
          <h2 className="section-title services-title" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '0' }}>
            <img src={logoIcon} alt="O" style={{ width: '2.8rem', height: '2.8rem', objectFit: 'contain', margin: '0 -0.1rem', border: '2px solid #B8860B', borderRadius: '50%', padding: '2px' }} />ur Services
          </h2>
          <p className="section-subtitle">Comprehensive production solutions for every vision</p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card" style={{ animationDelay: `${index * 0.1}s` }}>
              <div className="service-image-wrapper">
                <img src={service.image} alt={service.title} className="service-image" />
                <div className="service-image-overlay"></div>
              </div>
              <div className="service-card-content">
                <h3>{service.title}</h3>
                <p>{service.desc}</p>
                <Link to={service.path} className="learn-more">Learn More →</Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
